import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BarraDeBusqueda } from "../../Components/Empleado/BarraDeBusqueda";
import { EmpleadosAccordion } from "./../../Components/AccordionEmpleados/Empleados";

import Loading from "../../Components/Modals/Loading/Loader";
import Pagination from '@mui/material/Pagination';

import {
  selectAllEmpleados,
  selectEmpleadosIsLoading,
  selectEmpleadosCount,
  setUltimoFiltro,
  clearUltimoFiltro
} from "./../../redux/Empleados/EmpleadosSlice";

import { fetchAreasOrganizacionales } from "../../redux/AreaOrganizacional/AreaOrganizacionalSlice";
import { fetchCargosAll } from "../../redux/Cargos/CargosSlice";

import { makeStyles } from '@mui/styles';
import { loadEmpleados } from "./Funcs/Paginacion";
import { usePreviousRoute } from "../../context/PreviousRouteProvider";

  const useStyles = makeStyles(() => ({
    ul: {
      "& .MuiPaginationItem-root": {
        color: "#003876"
      },

    }
  }));

  // * VALORES INICIALES DEL FILTRO.
  let filtroInitialValuesState = {
    index: 0,
    itemsPerPage: 15,
    nombre: "",
    apellido: "",
    areaOrganizacionalId: 0,
    cargoId: 0,
    estado: 0,
    codigo: ""
  };

export function EmpleadosDesvinculados() {

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-PREVIOUS-ROUTE
  const previousRoute = usePreviousRoute(); // Obtener la ruta anterior

  // ? HOOK-SELECTOR
  const empleadosDesvinculados = useSelector(selectAllEmpleados);
  const empleadosLoading = useSelector(selectEmpleadosIsLoading);
  const empleaodsCount = useSelector(selectEmpleadosCount);
  const ultimoFiltro = useSelector(s => s.empleados.ultimoFiltro);

  // ? HOOK-STATE PARA PAGINACION
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);

  // ? HOOK-STATE PARA GUARDAR INFORMACIONES.
  const [filtroState, setFiltroState] = useState(Object.keys(ultimoFiltro).length > 0 ? ultimoFiltro : filtroInitialValuesState);
  
  // ? HOOK-STATE
  const [updateListApiState, setUpdateListApiState] = useState(false);

  // * FUNCIONES

  // * FUNCION PARA GUARDAR ULTIMO FILTRO.
  const saveUltimoFiltro = useCallback((filtro) => {
    dispatch(setUltimoFiltro(filtro));
  }, [dispatch]);
  

  // * FUNCION PARA LIMPIAR FILTRO.
  const cleanfilter = () => {
    
    // * LIMPIANDO HISTORICO DE REDUX.
    dispatch(clearUltimoFiltro());
    
    setPage(0);
    setFiltroState(filtroInitialValuesState);
    setUpdateListApiState(true);
 
  };

  const cargarEmpleados = () => {
    dispatch(loadEmpleados(filtroState)); 
    setPage(filtroState.index / filtroInitialValuesState.itemsPerPage);
  }

  const handleChangePage = (event, newPage) => {
    setUpdateListApiState(true);
    setFiltroState({...filtroState, index: (newPage - 1) * filtroInitialValuesState.itemsPerPage})
    setPage(newPage - 1);
  };

  // ? HOOK-EFFECT DE LAS LISTAS.
  useEffect(() => {
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchCargosAll());
  }, [])
  
  // ? HOOK-EFFECT PARA ACTUALIZAR LISTADO.
  useEffect(() => {
    
    if(updateListApiState){
      cargarEmpleados();
      setUpdateListApiState(false);
    }
    
  }, [updateListApiState, filtroState])

  // ? HOOK-EFFECT PARA LIMPIAR FILTROS E HISTORIAL SI EL USUARIO VIENE DE OTRA RUTA QUE NO
  // ? SEA DE EMPLEADOS.
  useEffect(() => {

    // * VALIDACIONES
    const validacionRutaEmpleado = previousRoute?.includes('/empleados');
    const validacionObjetoAlmacenado = Object.keys(ultimoFiltro).length > 0;
    const validacionEsMismoEstado = ultimoFiltro.estado === filtroInitialValuesState.estado;

    if (!validacionRutaEmpleado) {
      cleanfilter();
      return;
    }

    if (!validacionObjetoAlmacenado) {
      cargarEmpleados();
      return;
    }

    if (!validacionEsMismoEstado) {
      cleanfilter();
      return;
    }

    setFiltroState(ultimoFiltro);
    setUpdateListApiState(true);

  }, [previousRoute]); 
  
  const classes = useStyles();

  // * TOTAL DE PAGINAS PARA LA PAGINACION.
  const totalPages = Math.max(1, Math.ceil(empleaodsCount / rowsPerPage));

  return (
    <div className="container-fluid main">
      <div className="row">
        <div className="col-md-12">
          <div>
            <h3 className="text-primary-mem">EMPLEADOS DESVINCULADOS</h3>
            <hr />
          </div>

          <BarraDeBusqueda
          setUpdateListApiState={setUpdateListApiState}
          setFiltroState={setFiltroState}
          filtroState={filtroState}
          setSkipRow={setSkipRow}
          setPage={setPage}
          cleanfilter={cleanfilter}
          cargarEmpleados={cargarEmpleados}
          />

         {empleadosDesvinculados && empleadosDesvinculados.length > 0 && (
          <EmpleadosAccordion
            empleados={empleadosDesvinculados}
            saveUltimoFiltro={saveUltimoFiltro}
            filtroState={filtroState}
          />
        )}

        </div>

        {empleadosDesvinculados.length === 0 && (
          <p>No se encontraron empleados</p>
        )}

        <div className="p-4 d-flex justify-content-center">
          <Pagination 
          classes={{ ul: classes.ul }}
          variant="outlined" 
          shape="rounded"
          count={totalPages} 
          page={page + 1}
          onChange={handleChangePage}
          boundaryCount={10} 
          color="primary"
          />
        </div>

        <Loading open={empleadosLoading} />
      </div>
    </div>
  );
}

export default EmpleadosDesvinculados;
